export const usePluginPushProduct = () => {
    const extensions = () => {
        return {
            canPushProduct() {
                if (! this.permission.has('write')) {
                    this.logger.error('没有更新权限')
                    return false
                }

                const bn = this.BizNode[this.componentType ?? this.productType]

                if ('function' !== typeof bn.push) {
                    this.logger.error('不支持更新')
                    return false
                }

                return true
            },

            async cmdPushProduct() {
                await this.runAction(
                    () => this.execute(
                        async () => {
                            await this.pushProduct()
                            //this.selectNodes([this.root])
                        }
                    ),

                    {action: '更新模型制品'},
                )
            },

            async pushProduct() {
                const bn = this.BizNode[this.componentType ?? this.productType]
                await bn.push(this, this.root)
                this.logger.info('更新成功')
            },

            useCanPushProduct() {
                this.usePermission()
                return this.canPushProduct()
            },
        }
    }

    return {extensions}
}
